import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'

import { postBillRefundInPerson } from '../../dataClient/apiCalls'
import { BoldBodyText, BoldFormTitle, BoldSpan } from '../styles/Text'
import { FlexColumn, FlexEndContainer, PaddedForm, StyledDialog, StyledDialogContent } from '../styles/Containers'
import Button, { SecondaryButton } from '../common/Button'
import { ErrorMessage, SuccessMessage } from '../common/UserMessage'

function MarkRefundInPersonPopUp({ billId, secondaryId, open = false, onClose = () => {}, onSuccess = () => {} }) {
  const [isLoading, setIsLoading] = useState(false)
  const [error, setError] = useState(false)
  const [isCompleted, setIsCompleted] = useState(false)

  useEffect(() => {
    if (!open) return

    setError(false)
    setIsCompleted(false)
  }, [open])

  function handleDialogClose(event, reason) {
    if (isLoading) return
    onClose(event, reason)
  }

  function onSubmit(e) {
    e.preventDefault()
    setIsLoading(true)
    setError(false)

    postBillRefundInPerson(billId)
      .then(() => {
        setIsCompleted(true)
        onSuccess()
      })
      .catch(err => {
        console.error('Failed to mark bill refunded in person', billId, err)
        setError(true)
      })
      .finally(() => {
        setIsLoading(false)
      })
  }

  return (
    <StyledDialog
      fullWidth
      open={open}
      onClose={handleDialogClose}
      disableEscapeKeyDown={isLoading}
      keepMounted={false}
      aria-labelledby="mark-refund-in-person-pop-up">
      <StyledDialogContent>
        <PaddedForm onSubmit={onSubmit}>
          <FlexColumn gap="20px">
            <BoldFormTitle id="mark-refund-in-person-pop-up">Mark refund in person</BoldFormTitle>

            {isCompleted ? (
              <FlexColumn gap="20px">
                <SuccessMessage>
                  Bill <BoldSpan>{secondaryId}</BoldSpan> marked as refunded in person.
                </SuccessMessage>
              </FlexColumn>
            ) : (
              <FlexColumn gap="20px">
                <BoldBodyText>
                  Mark bill <BoldSpan>{secondaryId}</BoldSpan> as refunded in person (for example, cash refunded at the counter)?
                </BoldBodyText>
                {error && <ErrorMessage>There was an error updating the bill. Please try again.</ErrorMessage>}
              </FlexColumn>
            )}

            <FlexEndContainer>
              {isCompleted ? (
                <SecondaryButton type="button" onClick={onClose}>
                  Close
                </SecondaryButton>
              ) : (
                <>
                  <SecondaryButton type="button" onClick={onClose} disabled={isLoading}>
                    Cancel
                  </SecondaryButton>
                  <Button type="submit" loading={isLoading}>
                    Confirm
                  </Button>
                </>
              )}
            </FlexEndContainer>
          </FlexColumn>
        </PaddedForm>
      </StyledDialogContent>
    </StyledDialog>
  )
}

MarkRefundInPersonPopUp.propTypes = {
  billId: PropTypes.string.isRequired,
  secondaryId: PropTypes.string.isRequired,
  open: PropTypes.bool,
  onClose: PropTypes.func,
  onSuccess: PropTypes.func
}

export default MarkRefundInPersonPopUp
